var _rect, _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserFull = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 55,
    fill: "#4B5258"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9939 54.9995C63.7427 54.9995 70.835 48.4331 70.835 40.333C70.835 32.2329 63.7427 25.6665 54.9939 25.6665C46.2452 25.6665 39.1529 32.2329 39.1529 40.333C39.1529 48.4331 46.2452 54.9995 54.9939 54.9995Z",
    fill: "#E1D9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9994 59.1906C39.5131 59.1906 26.8216 70.2691 25.666 84.3332H84.3327C83.1771 70.2691 70.4856 59.1906 54.9994 59.1906Z",
    fill: "#E1D9CD"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userFull.631f4eb4.svg";
export { ForwardRef as ReactComponent };